import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import firebase from "firebase/app";
import "firebase/firestore";

interface Data {
   templateName: string;
   openRequests: number;
   closedRequests: number;
   elements: number;
}

export const initialState = {
   rows: [],
   filtered: false,
   cardsCopy: {}
};

export const templatesSlice = createSlice({
   name: "template",
   initialState,
   reducers: {
      setRowFilter: (state, action) => {
         state.rows = action.payload;
         state.filtered = true;
      },
      clearRowFilter: (state) => {
         state.rows = initialState.rows;
         state.filtered = false;
      },
      setCardsCopy: (state, action) => {
         state.cardsCopy = action.payload;
      }
   },
});

export const {
   setRowFilter,
   clearRowFilter,
   setCardsCopy
} = templatesSlice.actions;

export const getTemplatesData = (): AppThunk => (dispatch) => {
   var arrayResult = [];
   var resultStore = firebase.firestore();
   resultStore
      .collection("yearbook_templates")
      .get()
      .then((querySnapshot) => {
         querySnapshot.forEach((doc) => {
            const data = doc.data();
            arrayResult.push(data);
         });
         dispatch(setRowFilter(arrayResult));
      });
};

export const selectTemplatesRows = (state: any) => state.templateReducer.rows;
export const selectCardsCopy = (state: any) => state.templateReducer.cardsCopy;
export const selectTemplatesFiltered = (state: any) =>
   state.templateReducer.filtered;

export default templatesSlice.reducer;
